// Local
document.addEventListener('DOMContentLoaded', () => {
	for (const e of [...document.querySelectorAll('.disclosure-list a, #Linklist-language a')]) {
		const { host, origin, pathname } = new URL(e);
		if (host.includes('www')) {
			continue;
		}
		if (host.includes('.goldwin-global.com') || host.includes('.goldwin-sports.com')) {
			e.href = origin + (pathname !== '/' ? pathname : '') + location.pathname.replace('/de', '');
		}
	}

	if (Shopify.locale === 'de') {
		const selector = [
			'.header-item--navigation a[href*="https://www.goldwin-sports.com/eu/"]',
			'.header-item--navigation a[href*="https://www.goldwin-global.com/eu/"]',
			'#NavDrawer a[href*="https://www.goldwin-sports.com/eu/"]',
			'#NavDrawer a[href*="https://www.goldwin-global.com/eu/"]'
		];
		for (const link of document.querySelectorAll(selector.join())) {
			link.href = link.href.replace('/eu/', '/eu-de/');
		}
	}
});

// Megamenu Replace
{
	for (const link of document.querySelectorAll('#shopify-section-header [href*="/0"]')) {
		if (!link.innerHTML.includes('Goldwin 0')) {
			continue;
		}
		link.innerHTML = link.innerHTML.trim();
		link.innerHTML = link.innerHTML.replace('Goldwin 0', 'Goldwin <span class="font-helvetica">0</span>');
	}
};

;; ($ => {
	// Modal
	for (const toggle of $.querySelectorAll('[data-trigger="modal"]')) {
		const modal = $.querySelector(toggle.getAttribute('href'));

		if (modal !== null) {
			const inner = modal.querySelector('.modal');

			// Modal Open
			toggle.addEventListener('click', e => {
				e.preventDefault();

				modal.classList.add('modal-open');
				inner.style.display = 'flex';
			});

			// Modal Close
			const closeModal = (e = null) => {
				if (e === null || e.target.classList.contains('modal__inner') || e.target.closest('.modal__inner')) {
					return;
				}
				modal.classList.remove('modal-open');
				inner.style.display = 'none';
			};

			modal.addEventListener('click', closeModal);
			modal.querySelector('.modal__close').addEventListener('click', closeModal);
			$.onkeydown = e => {
				if (e.which === 27 || e.key === 'Escape') {
					closeModal(e);
				}
			};
		}
	};

	// Search result action
	if (location.pathname.includes('search')) {
		const hash = location.search.split('&');
		for (const i in hash) {
			if (hash[i].includes('q=') === false) {
				continue;
			}

			// Customer user
			if ($.body.dataset.customer === 'true' && location.search.includes('-tag%3Aoutlet') === true) {
				hash[i] = `q=${hash[i].replace('q=', '').split('+').filter(p => p !== '-tag%3Aoutlet').filter(Boolean).join('+')}`;
				location.href = location.pathname + hash.join('&');
				return;
			}

			// Guest user
			if ($.body.dataset.customer === 'false' && location.search.includes('-tag%3Aoutlet') !== true) {
				hash[i] = `q=${[...hash[i].replace('q=', '').split('+'), ...['-tag%3Aoutlet']].filter(Boolean).join('+')}`;
				location.href = location.pathname + hash.join('&');
				return;
			}
		}

		for (const input of $.querySelectorAll('[type="search"]')) {
			if (input.value.includes('-tag:outlet')) {
				input.value = input.value.replaceAll('-tag:outlet', '').replaceAll('  ', ' ');
			}
		}

		const container = $.querySelector('.main-content');
		container.style.opacity = 1;
	}

	// Product fixed Cartin
	const fix_cartin = $.querySelector('#fixed--cartin');
	if (fix_cartin !== null) {
		fix_cartin.addEventListener('click', e => {
			e.preventDefault();

			window.scroll({
				top: $.querySelector('.variant-wrapper').getBoundingClientRect().top + window.pageYOffset - 90,
				behavior: 'smooth'
			});
		});

		for (const evt of ['DOMContentLoaded', 'scroll']) {
			window.addEventListener(evt, () => {
				fix_cartin.closest('form').querySelector('[name="add"]').getBoundingClientRect().top < 0
					? fix_cartin.classList.remove('hidden')
					: fix_cartin.classList.add('hidden');
			});
		}
	}

	// Product tab is inside description
	const product_tabs = $.querySelectorAll('.product-tab');
	if (product_tabs.length > 0) {
		for (const container of product_tabs) {
			container.querySelector('.product-tab-title').addEventListener('click', e => {
				e.target.classList.toggle('is-active');
			});
		}
	}

	// Stock
	const submit = $.querySelector('[action="/cart/add"] [data-add-to-cart]');
	if (submit !== null) {
		const sale = $.querySelector('.product-block--sales-point');
		new MutationObserver(() => {
			sale.style.visibility = submit.disabled ? 'hidden' : 'initial';
		}).observe(submit, { attributes: true });
	}

	// Product review
	const product_review = {
		isCheckVariable: () => {
			const flg = setTimeout(product_review.isCheckVariable, 100);
			if (!window.junipLoaded) {
				return;
			}

			clearTimeout(flg);

			const container = $.querySelector('.shopify-app-block .junip-review-section');
			if (container !== null) {
				const observer = new MutationObserver(() => {
					observer.disconnect();

					container.querySelector('.junip-filters').remove();
					container.innerHTML = '<header class="section-header"><h3 class="section-header__title">Ratings & Reviews</h3></header>' + container.innerHTML;
				});
				observer.observe(container, { childList: true, subtree: true });
			}
		}
	};
	product_review.isCheckVariable();

	// Wish List

	// Customer Content
	if (location.pathname.includes('/account')) {
		// Success
		if (location.search.includes('success=address_add')) {
			$.querySelector('.note.add').classList.remove('hide');
		}

		if (location.search.includes('success=address_update')) {
			$.querySelector('.note.edit').classList.remove('hide');
		}

		// Tab change
		const account = { tabs: [...$.querySelectorAll('.tabs a')], container: [...$.querySelectorAll('.account__container')] };
		for (const i in account.tabs) {
			const toggled = () => {
				for (const t of account.tabs) t.classList.remove('active');
				for (const c of account.container) c.classList.remove('active');

				account.tabs[i].classList.add('active');
				account.container[i].classList.add('active');
			}
			account.tabs[i].addEventListener('click', () => toggled());

			if (location.hash.includes(account.tabs[i].getAttribute('href'))) {
				toggled();
			}
		}

		// WishList action
		const container = { empty: $.querySelector('[data-wishlist-status="empty"]'), product: $.querySelector('[data-wishlist-status="products"]') };
		const wishlistProducts = [];
		if (!window.SwymCallbacks) {
			window.SwymCallbacks = [];
		}
		window.SwymCallbacks.push(function () {
			_swat.fetchWrtEventTypeET(products => {
				for (const i in products) {
					const product = products[i];
					const price = product.pr.toFixed(2);
					console.log(product);

					if (wishlistProducts.indexOf(product) === -1) {
						const item = Object.assign($.createElement('div'), {
							className: 'grid__item grid-product small--one-half medium-up--one-third',
							innerHTML: `
							<div class="grid-product__content">
								<button class="wishlist__product__delete js-wishlist-remove" data-product-id="${product._id}"></button>
								<a href="${product.du}" class="grid-product__link">
									<div class="grid-product__image-mask">
										<div class="grid__image-ratio grid__image-ratio--square">
											<img class="grid__image-contain lazyautosizes lazyload" data-src="${product.iu}" data-widths="[360, 540, 720, 900, 1080]" data-sizes="auto">
										</div>
									</div>
									<div class="grid-product__meta">
										<div class="grid-product__title">${product.dt}</div>
										<div class="grid-product__price">${theme.settings.moneyFormat.split('{')[0]}${price}</div>
									</div>
								</a>
							</div>`.split('\n').map(l => l.trim()).join('')
						});

						container.product.append(item);
						wishlistProducts.push(product);
					}
				}
				if (products.length > 0) {
					container.empty.remove();
				}
			}, _swat.EventTypes.addToWishlist);
		});

		container.product.addEventListener('click', e => {
			if (e.target && e.target.classList.contains('js-wishlist-remove')) {
				_swat.deleteEvent(function callback() {
					location.reload();
				}, e.target.dataset.productId);
			}
		});
	}

	// Collection filter in sort
	const filter = $.querySelector('#FilterDrawer');
	if (filter !== null) {
		const sorts = filter.querySelectorAll('[name="SortByRadio"]');
		for (const sort of sorts) {
			sort.addEventListener('change', () => {
				const queryParams = new URLSearchParams(window.location.search);
				queryParams.set('sort_by', sort.value);
				queryParams.delete('page');

				window.location.search = queryParams.toString();
			});
		}
	}

  

  // ::::: 2023.07.13 楠本追加 - バリアントボタンクリック時にdisableがついているかどうかで fixed--cartin のテキストを差し替える:::::
  {
    const $fixedCartIn = $.getElementById('fixed--cartin');
    const $valiantInputAll = $.querySelectorAll('.variant-input');

    const buttonLabels = {
      add_cart: "Add to cart",
      sold_out: "Sold Out",
    }

    const handleValiantInputChange = (e)=>{
      if(e.target.classList.contains('disabled')) {
        $fixedCartIn.textContent = buttonLabels.sold_out;
      } else {
        $fixedCartIn.textContent = buttonLabels.add_cart;
      }
    }
    $valiantInputAll.forEach(($input)=>{
      const $radio = $input.querySelector('input[type="radio"]');
      $radio.addEventListener('change', handleValiantInputChange)
    })

  }
})(document);

